__webpack_require__.p = "https://www.ikea.com/us/en/purchase-agent/cart-tmp/";